import { Environment } from '@zippie/did-core'
import axios from 'axios'

import { BACKEND_URL } from '../constants/apis'

export const getEnv = () => {
  const { origin } = window.location
  if (origin.includes('localhost')) {
    return Environment.dev
  }
  if (origin.includes('dashboard2')) {
    return 'dev2'
  }
  if (origin.includes('dashboard3')) {
    return 'dev3'
  }
  if (origin.includes('dev')) {
    return Environment.dev
  }
  if (origin.includes('test')) {
    return Environment.test
  }
  return Environment.prod
}

const env = getEnv()
const baseURL = BACKEND_URL[env]
const apiClient = axios.create({
  baseURL,
  withCredentials: true,
})

export { env }
export default apiClient
